import { Plugin, type Runtime } from "@squide/firefly";
import { CommandMenuLinksRegistry, type CommandMenuLink } from "./CommandMenuLinksRegistry.ts";

const COMMAND_MENU_LINKS_REGISTRY_PLUGIN_NAME = "command-menu-links-registry";

export class CommandMenuLinksRegistryPlugin extends Plugin {
    readonly #registry = new CommandMenuLinksRegistry();

    constructor(runtime: Runtime) {
        super(COMMAND_MENU_LINKS_REGISTRY_PLUGIN_NAME, runtime);
    }

    registerLink(link: CommandMenuLink) {
        this.#registry.registerLink(link);
    }

    onDeferredRegistrationScopeStarted() {
        return this.#registry.beginDeferredScope();
    }

    getSnapshot = (): readonly CommandMenuLink[] => {
        return this.#registry.getSnapshot();
    };
}

export function getCommandMenuLinksRegistryPlugin(runtime: Runtime): CommandMenuLinksRegistryPlugin | undefined {
    const plugin = runtime.getPlugin(COMMAND_MENU_LINKS_REGISTRY_PLUGIN_NAME, { throwOnNotFound: false });

    return plugin as CommandMenuLinksRegistryPlugin | undefined;
}

export function createCommandMenuLinksRegistryPlugin(runtime: Runtime) {
    return new CommandMenuLinksRegistryPlugin(runtime);
}
